import React from 'react'
import { ElementType, forwardRef, HTMLAttributes } from 'react'
import classNames from 'classnames'
import { Link } from '../Link'

export interface PaginationItemProps extends HTMLAttributes<HTMLAnchorElement> {
    active?: boolean
    component?: string | ElementType
    disabled?: boolean
}

const PaginationItem = forwardRef<HTMLAnchorElement, PaginationItemProps>(({
    className,
    component,
    onClick,
    active,
    disabled,
    children,
    ...otherProps
}, ref) => {

    const Component = component ?? 'button'

    //we don't want to remove the button because then we lose focus area, so fake it
    const off = active || disabled

    const handleOnClick = (e) => {
        (!off) && onClick(e)
    }

    return (
        <li
            className={classNames(
                'page-item',
                {
                    active: active,
                    disabled: disabled
                },
                className
            )}
            {...(active && { 'aria-current': 'page' })}>
            {(Component === 'button') ? (
                <Link
                    ref={ref}
                    className="page-link"
                    component={Component}
                    onClick={handleOnClick}
                    tabIndex={off ? -1 : 0}
                    {...otherProps}
                >
                    {children}
                </Link>
            ) : (
                <Component
                    ref={ref}
                    className="page-link"
                    onClick={handleOnClick}
                >
                    {children}
                </Component>
            )}
        </li>
    )
})

export { PaginationItem }
